const accordionBlocks = document.querySelectorAll('.accordion-item');
const accordionHiddenElements = document.querySelectorAll('.accordion-item > .accordion-item__hidden');
const accordionShownElements = document.querySelectorAll('.accordion-item > .accordion-item__shown');

accordionShownElements.forEach(shownEl => {
  shownEl.addEventListener('click', function () {
    const parent = shownEl.parentElement;

    if (parent.classList.contains('accordion-item_open')) {
      accordionHiddenElements.forEach(hiddenEl => {hiddenEl.style.height = '0';});
      accordionBlocks.forEach(block => block.classList.remove('accordion-item_open'));
    } else {
      accordionHiddenElements.forEach(hiddenEl => {hiddenEl.style.height = '0';});
      accordionBlocks.forEach(block => block.classList.remove('accordion-item_open'));

      const hiddenEl = shownEl.nextElementSibling;
      if (hiddenEl) {
        hiddenEl.style.height = hiddenEl.scrollHeight + 'px';
      }
      parent.classList.add('accordion-item_open');
    }
  });
});

document.onclick = function (e) {
  if (e.target.classList.contains('js-preview-image')) {
    e.target.style.display = 'none';
    e.target.nextElementSibling.tabIndex = 0;

    if(e.target.parentElement.classList.contains('js-embed-video')) {
      e.target.nextElementSibling.src += "&autoplay=1";
    } else {
      e.target.nextElementSibling?.play();
    }
  }
};
